export class Search {
	static readonly type = '[financialInstitutionBranchSearch] search';
	constructor(
		public payload: { searchValue: string; institutionId?: string },
	) {}
}
